import { useCallback, useState } from "react";
import useInterfaceSoundCore from "@/shared/hooks/useInterfaceSoundCore";
import { Soundtrack } from "@/shared/sounds";
import { Confirm } from "@/shared/ui";
import useCreateCharacter from "@/domains/account/hooks/useCreateCharacter";
import AccountCharAvailable from "@/domains/account/components/char/AccountCharAvailable.tsx";

export default function AccountCharCreateContainer() {
  const { play } = useInterfaceSoundCore(Soundtrack.EnterGame);
  const { createCharacterHandler, isPending } = useCreateCharacter();
  const [open, setOpen] = useState(false);

  const onToogleModal = useCallback(() => {
    setOpen((state) => !state);
  }, []);

  const onConfirm = useCallback(async () => {
    play();
    await createCharacterHandler();
  }, [play, createCharacterHandler]);

  return (
    <>
      <AccountCharAvailable onClick={onToogleModal} />
      <Confirm open={open} onConfirm={onConfirm} onCancel={onToogleModal} pending={isPending}>
        <div className="text-white text-16 font-bold text-center">
          Отправиться в новое путешествие?
        </div>
      </Confirm>
    </>
  );
}
